export const sortByOrder = (columns = []) => (
  [...columns].sort((a, b) => a.order - b.order)
)

export const withOrder = (columns) => (
  columns.map((column, index) => ({ ...column, order: index + 1 }))
)

/** Merge API saved columns with local defaults (defaults define keys + fallback visibility) */
export const mergeColumns = (defaults, saved) => {
  if (!saved?.length) return [...defaults]

  const savedByKey = Object.fromEntries(saved.map((column) => [column.key, column]))
  const merged = defaults.map((column) => savedByKey[column.key] || column)
  const defaultKeys = new Set(defaults.map((column) => column.key))

  saved.forEach((column) => {
    if (!defaultKeys.has(column.key)) merged.push(column)
  })

  return withOrder(sortByOrder(merged))
}

export const reorderColumns = (columns, sourceIndex, destinationIndex) => {
  if (destinationIndex == null) return columns
  const next = [...columns]
  next.splice(destinationIndex, 0, next.splice(sourceIndex, 1)[0])
  return withOrder(next)
}

export const toggleColumn = (columns, key, visible) => (
  columns.map((column) => (column.key === key ? { ...column, visible } : column))
)

export const getVisibleItems = (columns, extraFilter) => (
  sortByOrder(columns).filter((column) => column.visible && (!extraFilter || extraFilter(column)))
)
